import React, { useState } from "react";
import { Input, Button } from "antd";
import SearchIcon from "../../../../Assets/svg/searchIcon.svg";
import "../VisitBoard/VisitBoard.scss";

const FacilitiesFilter = ({ filters, onFiltersChange }) => {
  const [search, setSearch] = useState(filters?.Search || "");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (onFiltersChange) onFiltersChange({ Search: value });
  };

  const handleClear = () => {
    setSearch("");
    if (onFiltersChange) onFiltersChange({ Search: "" });
  };

  return (
    <div className="filtersWrapper">
      <div className="containerFilters">
        <Input
          placeholder="Search..."
          onChange={handleSearchChange}
          suffix={<img src={SearchIcon} alt="search icon" />}
          value={search}
        />
        <Button className="clearButton" onClick={handleClear}>
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default FacilitiesFilter; 